import { initializerDefineProperty as _initializerDefineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from "\0rollupPluginModLoBabelHelpers.js";
import { initializerWarningHelper as _initializerWarningHelper } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "b4fcdna/7xFzKA/oCCJnSM9", "Gift", undefined);

import { _decorator, Component, Node, Label, UITransform, tween, v3, UIOpacity, Sprite } from 'cc';
import { E_ADEventType, E_AdType, E_PlatformType, E_ResPath } from './common/EnumBase';
import { App } from './common/manager/App';
var ccclass = _decorator.ccclass,
    property = _decorator.property;
export var Gift = (_dec = ccclass('Gift'), _dec2 = property(Node), _dec3 = property(Node), _dec4 = property(Node), _dec5 = property(Node), _dec6 = property(Node), _dec7 = property(Label), _dec8 = property(Node), _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Gift, _Component);

  function Gift() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _initializerDefineProperty(_assertThisInitialized(_this), "n_light", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_line", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_ad", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_next", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_mask", _descriptor5, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "lbl_pg", _descriptor6, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_gain", _descriptor7, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "_isActPg", false);

    _defineProperty(_assertThisInitialized(_this), "_trs_mask", null);

    _defineProperty(_assertThisInitialized(_this), "_pg_aim", 0);

    _defineProperty(_assertThisInitialized(_this), "_t_run", 0);

    _defineProperty(_assertThisInitialized(_this), "_t_cur", 0);

    return _this;
  }

  var _proto = Gift.prototype;

  _proto.start = function start() {
    // [3]
    App.GameCtrl.addBtnEvent(this.node, this.btn_event.bind(this));
  };

  _proto.enter = function enter() {
    var _this2 = this;

    this.node.setPosition(0, 0, 0);
    this._trs_mask = this.n_mask.getComponent(UITransform);
    this.node.active = true;
    this.n_gain.active = false;
    this.n_mask.active = true;
    this.lbl_pg.node.active = true;
    this._trs_mask.height = 0;
    this.node.scale = v3(0, 0, 0);
    tween(this.node).to(0.35, {
      scale: v3(1, 1, 1)
    }, {
      easing: "backOut"
    }).call(function () {
      _this2.actGiftEnter();
    }).start();
    this.addEventListener();
  };

  _proto.onDestroy = function onDestroy() {
    this.removeEventListener();
  };

  _proto.addEventListener = function addEventListener() {
    App.AdEventMgr.addEventLintener(E_ADEventType.video_showOver, this.handle_adSucc, this);
  };

  _proto.removeEventListener = function removeEventListener() {
    App.AdEventMgr.removeEvent(this);
  };

  _proto.handle_adSucc = function handle_adSucc() {
    if (App.AdCtrl.type == E_AdType.Gift) {
      App.DataMgr.lineUnlock += "," + App.DataMgr.giftLineIndex;
      App.DataMgr.lineOwn += "," + App.DataMgr.giftLineIndex;
      this.exit(0.3);
    }
  };

  _proto.btn_event = function btn_event(btn) {
    switch (btn.node.name) {
      case "n_ad":
        App.AdCtrl.type = E_AdType.Gift;

        if (App.AdCtrl.platformType == E_PlatformType.Normal) {
          this.handle_adSucc();
        } else {
          App.AdCtrl.showRewardedVideoAd();
        }

        break;

      case "n_next":
        App.DataMgr.lineUnlock += "," + App.DataMgr.giftLineIndex;
        this.exit(0.3);
        break;
    }
  };

  _proto.actGiftEnter = function actGiftEnter() {
    var _this3 = this;

    //礼盒进度
    var aimPg = App.DataMgr.giftPg; //动作

    var h = 304;
    aimPg += 0.17;
    App.DataMgr.giftPg = aimPg;
    if (aimPg > 1) aimPg = 1;
    this._pg_aim = aimPg;
    var t = aimPg / 1 * 1;
    this._t_run = t;
    this._t_cur = 0; //礼盒

    this._isActPg = true;
    tween(this._trs_mask).to(t, {
      height: aimPg * h
    }).call(function () {
      _this3._isActPg = false;

      _this3.checkGain();
    }).start();
  };

  _proto.checkGain = function checkGain() {
    if (this._pg_aim == 1) {
      this.actGiftShake();
      this.actGainLine();
      App.DataMgr.giftPg = 0;
    } else {
      this.exit();
    }
  };

  _proto.actGiftShake = function actGiftShake() {
    var _this4 = this;

    //缩放
    tween(this.n_mask).repeat(2, tween().to(0.15, {
      scale: v3(1.2, 1.2, 1.2)
    }).to(0.15, {
      scale: v3(1, 1, 1)
    })).to(0.15, {
      scale: v3(2, 2, 2)
    }).start(); //透明度

    var uiOpacity = this.n_mask.getComponent(UIOpacity);
    tween(uiOpacity).delay(0.6).to(0.15, {
      opacity: 0
    }).call(function () {
      _this4.lbl_pg.node.active = false;
    }).start();
  };

  _proto.actGainLine = function actGainLine() {
    var _this5 = this;

    tween(this.n_next).delay(1).call(function () {
      _this5.n_mask.active = false;
      _this5.n_mask.scale = v3(1, 1, 1);
      _this5.n_mask.getComponent(UIOpacity).opacity = 255;
      _this5.n_gain.active = true;
      _this5.n_next.active = false;
    }).delay(1).call(function () {
      _this5.n_next.active = true;
    }).start();
    var lineIndex = App.DataMgr.giftLineIndex;
    App.ResMgr.loadSf(this.n_line.getComponent(Sprite), E_ResPath.Tex_LineShowRoot + "lineS" + lineIndex);
  };

  _proto.exit = function exit(dt) {
    var _this6 = this;

    if (dt === void 0) {
      dt = 1.5;
    }

    var lineOwn = App.DataMgr.lineUnlock;
    var lineOwnArr = lineOwn.split(",");
    var lineOwnNArr = [];

    for (var i = 0; i < lineOwnArr.length; i++) {
      lineOwnNArr.push(parseInt(lineOwnArr[i]));
    }

    var lineAll = App.ArrayHandler.create_int(10);
    lineAll = App.ArrayHandler.filter(lineAll, lineOwnNArr);

    if (lineAll.length > 0) {
      App.DataMgr.giftLineIndex = lineAll[App.NumHandler.round_int(lineAll.length)]; // App.DataMgr.giftPg = 0;
    } else {
      App.DataMgr.giftLineIndex = -1;
    }

    tween(this.node).delay(dt).to(0.35, {
      position: v3(-this.node.getComponent(UITransform).width, 0, 0)
    }).call(function () {
      _this6.node.active = false;
    }).start();
  };

  _proto.update = function update(dt) {
    if (this._isActPg) {
      this._t_cur += dt;
      this.lbl_pg.string = Math.round(this._t_cur / this._t_run * this._pg_aim * 100) + "%";
    }
  };

  return Gift;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "n_light", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "n_line", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "n_ad", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "n_next", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "n_mask", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "lbl_pg", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "n_gain", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
})), _class2)) || _class);
/**
 * [1] Class member could be defined like this.
 * [2] Use `property` decorator if your want the member to be serializable.
 * [3] Your initialization goes here.
 * [4] Your update function goes here.
 *
 * Learn more about scripting: https://docs.cocos.com/creator/3.0/manual/en/scripting/
 * Learn more about CCClass: https://docs.cocos.com/creator/3.0/manual/en/scripting/ccclass.html
 * Learn more about life-cycle callbacks: https://docs.cocos.com/creator/3.0/manual/en/scripting/life-cycle-callbacks.html
 */

_cclegacy._RF.pop();